var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"#000000","strokeMiterlimit":"10","points":"5.38,5.75 13.74,14.11 5.38,22.48 "}));
}

Right.defaultProps = {"viewBox":"5 5 10 18"};

module.exports = Right;

Right.default = Right;
